import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { App } from "../App";
import { Token, WalletControllerBase } from "../controllers/WalletControllerBase";
import { BiMath } from "../libs/BiMath";
import { ERC20Contract } from "../contracts/ERC20Contract";

export class CmpWidgetShareXTokens extends com.CmpWidgetShareXTokensBase {

    constructor() {
        super();
        this.ctrls.btnAdd.onclick=async ()=>{
            const wallet = App.Inst.getInst(WalletControllerBase);
            if (!wallet) return;
            let addresses = this.ctrls.cmpSearch.ctrls.iSearch.value;
            addresses = gs.text.replaceAll(addresses,"\"","");
            addresses = gs.text.replaceAll(addresses,"'","");
          //  addresses = gs.text.replaceAll(addresses,"]"," ");
          //  addresses = gs.text.replaceAll(addresses,"["," ");
            this.disable();
            for(let address of addresses.split(','))
            {
                address=address.trim();
                if (!address) continue;

                 if (!BiMath.isValidAddress(address))
                {
                    App.gui.dialogOkShowAsync("Invalid address: "+address);
                    continue;
                }
                if (wallet.hasToken(address)) continue;
                let token = new Token();
                try
                {
                    const erc20 = new ERC20Contract(address, App.chain.provider);
                    token.name = await erc20.name();
                    if (!token.name) throw new Error();
                    token.symbol = await erc20.symbol();
                    if (!token.symbol) throw new Error();
                    let decimals = await erc20.decimals();
                    if (!decimals) throw new Error();
                    token.decimal = parseInt(decimals);
                    token.address = address;
                } catch(e)
                {
                    App.gui.dialogOkShowAsync("Is '"+address+"' ERC20?");
                    continue;
                }
                wallet.addToken(token);
            }
            this.enable();
            this.ctrls.cmpSearch.ctrls.iSearch.value='';
            this.refreshAsync();
        }
    }

    public initialize()
    {
        this.refreshAsync();
    }

    public async refreshAsync()
    {
        const wallet = App.Inst.getInst(WalletControllerBase);
        if (!wallet) return;
        const tokens = wallet.getTokens();
        this.ctrls.list.html='';
        for(const t of tokens)
        {
            const adr = t.address.substring(0,14)+".."+t.address.substring(t.address.length-12,t.address.length);
            const item = gs.w(gs.html.span({}));
            item.text = t.name+":\n"+adr;
            this.ctrls.list.append(item);
            item.onclick=()=>{
                item.cut();
                wallet.removeToken(t.address);
                this.refreshAsync();
            }
        }
    }


}